import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_BASE_URL } from "../config";
import { Container, Row, Col, Button, Card, Spinner } from "react-bootstrap";
import { useLoading } from "../contexts/LoadingContext";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import "./DoctorProfile.css"; // Custom CSS for additional styling

const SpecialistDoctorProfile = () => {
  const [doctorProfile, setDoctorProfile] = useState(null);
  const [showFullAbout, setShowFullAbout] = useState(false);
  const { isLoading, setIsLoading } = useLoading();
  const navigate = useNavigate();
  const { id } = useParams();
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const session = JSON.parse(sessionStorage.getItem("user"));

  const handleLogout = () => {
    setIsLoggedIn(false);
  };

  // Fix: Use same video call flow as doctor-list-component
  const handleCallNow = () => {
    if (!session?.payLoad?.access_token) {
      Swal.fire({
        icon: "info",
        title: "Login",
        text: "Please login first",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      }).then(() => {
        navigate(`/login/doctor-profile`);
        return;
      });
    } else if (!session?.payLoad.user.userPackages) {
      navigate("/packages");
    } else if (doctorProfile?.Email) {
      // Pass appointment id (dummy 1), email, and doctor ID
      var fromCall = 'doctorProfile'
      navigate(`/video-call`, {
        state: { appointment: 1, email: doctorProfile.Email, doctorId: id, fromCall },
      });
    } else {
      Swal.fire("Error", "Doctor email not found.", "error");
    }
  };

  useEffect(() => {
    const fetchDoctorProfile = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(
          `${API_BASE_URL}/specialist/view?user_id=${id}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch doctor profile");
        }
        const data = await response.json();
        if (data.statusCode === 1 && data.payLoad) {
          setDoctorProfile(data.payLoad);
        } else {
          throw new Error("Invalid response format");
        }
      } catch (error) {
        console.error("Error fetching doctor profile:", error);
        Swal.fire("Error!", "Failed to load doctor profile.", "error");
      } finally {
        setIsLoading(false);
      }
    };

    fetchDoctorProfile();
  }, [id, setIsLoading]);

  const toggleShowFullAbout = () => {
    setShowFullAbout((prev) => !prev);
  };

  if (isLoading) {
    return <Loader />;
  }

  if (!doctorProfile) {
    return (
      <Container>
        <h2>No doctor profile found.</h2>
      </Container>
    );
  }

  return (
    <>
      <Navbar isLoggedIn={isLoggedIn} onLogout={handleLogout} />
      <Container fluid className="mt-3 mb-4">
        <Row className="justify-content-center">
          <Col md={8} lg={7}>
            <Card className="shadow-lg border-0 rounded">
              <Card.Header className="text-center bg-primary text-white">
                <div className="d-flex justify-content-center align-items-center mt-4">
                  <Col md={4} lg={3} className="text-center mb-4 mb-md-0">
                    <img
                      src={doctorProfile.ImgLink}
                      alt="Doctor Profile"
                      className="img-fluid rounded-circle border border-light"
                      style={{ width: "150px", height: "150px" }}
                    />
                  </Col>
                </div>
                <Row>
                  <h2 className="mb-0 text-white">{doctorProfile.FirstName}</h2>
                </Row>
                <Row>
                  <div>
                    <span className="badge bg-warning text-dark">
                      {doctorProfile.AverageRating
                        ? doctorProfile.AverageRating.toFixed(1)
                        : "N/A"}
                    </span>
                    <span className="text-white">
                      {" "}
                      ({doctorProfile.RatingCount} reviews)
                    </span>
                  </div>
                </Row>
              </Card.Header>
              <Card.Body>
                <Card.Text className="mb-4" style={{ fontSize: "0.875rem" }}>
                  <strong>Experience:</strong> {doctorProfile.Experience}
                  <br />
                  <strong>Duty Time:</strong> {doctorProfile.DoctorDutyTime}
                  <br />
                  <strong>Qualifications:</strong>{" "}
                  {doctorProfile.Allqualifications}
                  <br />
                  <strong>About:</strong>
                  <span
                    className={`justify-text ${
                      showFullAbout ? "" : "line-clamp"
                    }`}
                  >
                    {doctorProfile.DetailedInformation}
                  </span>
                  {!showFullAbout && (
                    <Button
                      variant="link"
                      onClick={toggleShowFullAbout}
                      style={{ fontSize: "0.875rem" }}
                    >
                      Show more
                    </Button>
                  )}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
};

export default SpecialistDoctorProfile;
